<ng-container *ngIf="!isVideo else VideoIcon">
  <svg-icon [svgStyle]="{ 'width.px': width, 'height.px': height }"
    [src]="iconPath"></svg-icon>
</ng-container>
<ng-template #VideoIcon>
  <img
    class="mini-preview"
    [src]="iconVideoPath"
    [width]="38"
    [height]="height">
</ng-template>